
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import FormFlowWrapper from '../common/form/FormFlowWrapper.vue';
import { BrandingImageType } from 'ah-api-gateways';
import PeopleWavingIcon from 'ah-common-lib/src/icons/components/PeopleWavingIcon.vue';
import HeadquartersIcon from 'ah-common-lib/src/icons/components/HeadquartersIcon.vue';

/**
 * Client self registration type selection
 *
 * Will display 'Individual' and 'Company' options
 *
 * Emits:
 *
 * - update:selected (payload: string): emmited when user chooses one of the possible options
 */
@Component({
  components: {
    FormFlowWrapper,
    PeopleWavingIcon,
    HeadquartersIcon,
  },
})
export default class RegistrationTypeSelection extends Vue {
  @Prop({ default: '' }) selected!: 'company' | 'personal' | '';

  private selection: 'company' | 'personal' | '' = '';

  @Watch('selected', { immediate: true })
  onSelectedChange() {
    this.selection = this.selected;
  }

  select(selection: 'company' | 'personal') {
    this.selection = this.selection === selection ? '' : selection;
  }

  get splashLogoLink() {
    let out = this.$theme.val?.logos.find((l) => l.type === BrandingImageType.SPLASH_IMAGE)?.link;
    return out;
  }

  get isSmallScreen() {
    return this.$mediaQuery.is('mdDown');
  }
}
